"use strict";

var _defineProperty = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step2;
    try {
      var _loop = function _loop() {
        var key = _step2.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ELEMENT_CODE_BLOCK: function ELEMENT_CODE_BLOCK() {
    return _ELEMENT_CODE_BLOCK;
  },
  ELEMENT_CODE_LINE: function ELEMENT_CODE_LINE() {
    return _ELEMENT_CODE_LINE;
  },
  ELEMENT_CODE_SYNTAX: function ELEMENT_CODE_SYNTAX() {
    return _ELEMENT_CODE_SYNTAX;
  },
  createCodeBlockPlugin: function createCodeBlockPlugin() {
    return _createCodeBlockPlugin;
  },
  decorateCodeLine: function decorateCodeLine() {
    return _decorateCodeLine;
  },
  deleteStartSpace: function deleteStartSpace() {
    return _deleteStartSpace;
  },
  deserializeHtmlCodeBlock: function deserializeHtmlCodeBlock() {
    return _deserializeHtmlCodeBlock;
  },
  getCodeLineEntry: function getCodeLineEntry() {
    return _getCodeLineEntry;
  },
  getCodeLineType: function getCodeLineType() {
    return _getCodeLineType;
  },
  getIndentDepth: function getIndentDepth() {
    return _getIndentDepth;
  },
  indentCodeLine: function indentCodeLine() {
    return _indentCodeLine;
  },
  insertCodeBlock: function insertCodeBlock() {
    return _insertCodeBlock;
  },
  insertCodeLine: function insertCodeLine() {
    return _insertCodeLine;
  },
  insertEmptyCodeBlock: function insertEmptyCodeBlock() {
    return _insertEmptyCodeBlock;
  },
  insertFragmentCodeBlock: function insertFragmentCodeBlock() {
    return _insertFragmentCodeBlock;
  },
  isCodeBlockEmpty: function isCodeBlockEmpty() {
    return _isCodeBlockEmpty;
  },
  isSelectionAtCodeBlockStart: function isSelectionAtCodeBlockStart() {
    return _isSelectionAtCodeBlockStart;
  },
  normalizeCodeBlock: function normalizeCodeBlock() {
    return _normalizeCodeBlock;
  },
  onKeyDownCodeBlock: function onKeyDownCodeBlock() {
    return _onKeyDownCodeBlock;
  },
  outdentCodeLine: function outdentCodeLine() {
    return _outdentCodeLine;
  },
  toggleCodeBlock: function toggleCodeBlock() {
    return _toggleCodeBlock;
  },
  unwrapCodeBlock: function unwrapCodeBlock() {
    return _unwrapCodeBlock;
  },
  useCodeBlockCombobox: function useCodeBlockCombobox() {
    return _useCodeBlockCombobox;
  },
  useCodeBlockComboboxState: function useCodeBlockComboboxState() {
    return _useCodeBlockComboboxState;
  },
  useCodeBlockElementState: function useCodeBlockElementState() {
    return _useCodeBlockElementState;
  },
  useCodeSyntaxLeaf: function useCodeSyntaxLeaf() {
    return _useCodeSyntaxLeaf;
  },
  useToggleCodeBlockButton: function useToggleCodeBlockButton() {
    return _useToggleCodeBlockButton;
  },
  withCodeBlock: function withCodeBlock() {
    return _withCodeBlock;
  }
});
module.exports = __toCommonJS(src_exports);

// src/client/createCodeBlockPlugin.ts
var import_server17 = require("@udecode/plate-common/server");

// src/shared/constants.ts
var _ELEMENT_CODE_BLOCK = "code_block";
var _ELEMENT_CODE_LINE = "code_line";
var _ELEMENT_CODE_SYNTAX = "code_syntax";

// src/shared/deserializeHtmlCodeBlockPre.ts
var _deserializeHtmlCodeBlock = {
  getNode: function getNode(el) {
    var _a, _b;
    var languageSelectorText = ((_a = _toConsumableArray(el.childNodes).find(function (node) {
      return node.nodeName === "SELECT";
    })) == null ? void 0 : _a.textContent) || "";
    var textContent = ((_b = el.textContent) == null ? void 0 : _b.replace(languageSelectorText, "")) || "";
    var lines = textContent.split("\n");
    if (!(lines == null ? void 0 : lines.length)) {
      lines = [textContent];
    }
    var codeLines = lines.map(function (line) {
      return {
        children: [{
          text: line
        }],
        type: _ELEMENT_CODE_LINE
      };
    });
    return {
      children: codeLines,
      type: _ELEMENT_CODE_BLOCK
    };
  },
  rules: [{
    validNodeName: "PRE"
  }, {
    validNodeName: "P",
    validStyle: {
      fontFamily: "Consolas"
    }
  }]
};

// src/shared/insertFragmentCodeBlock.ts
var import_server = require("@udecode/plate-common/server");
function extractCodeLinesFromCodeBlock(node) {
  return node.children;
}
var _insertFragmentCodeBlock = function _insertFragmentCodeBlock(editor) {
  var insertFragment = editor.insertFragment;
  var codeBlockType = (0, import_server.getPluginType)(editor, _ELEMENT_CODE_BLOCK);
  var codeLineType = (0, import_server.getPluginType)(editor, _ELEMENT_CODE_LINE);
  function convertNodeToCodeLine(node) {
    return {
      children: [{
        text: (0, import_server.getNodeString)(node)
      }],
      type: codeLineType
    };
  }
  return function (fragment) {
    var _a;
    var _ref = (_a = (0, import_server.getBlockAbove)(editor)) != null ? _a : [],
      _ref2 = _slicedToArray(_ref, 1),
      blockAbove = _ref2[0];
    if (blockAbove && [codeBlockType, codeLineType].includes(blockAbove == null ? void 0 : blockAbove.type)) {
      return insertFragment(fragment.flatMap(function (node) {
        var element = node;
        return element.type === codeBlockType ? extractCodeLinesFromCodeBlock(element) : convertNodeToCodeLine(element);
      }));
    }
    return insertFragment(fragment);
  };
};

// src/shared/normalizers/normalizeCodeBlock.tsx
var import_server3 = require("@udecode/plate-common/server");

// src/shared/options/getCodeLineType.ts
var import_server2 = require("@udecode/plate-common/server");
var _getCodeLineType = function _getCodeLineType(editor) {
  return (0, import_server2.getPluginType)(editor, _ELEMENT_CODE_LINE);
};

// src/shared/normalizers/normalizeCodeBlock.tsx
var _normalizeCodeBlock = function _normalizeCodeBlock(editor) {
  var codeBlockType = (0, import_server3.getPluginType)(editor, _ELEMENT_CODE_BLOCK);
  var codeLineType = _getCodeLineType(editor);
  var normalizeNode = editor.normalizeNode;
  return function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      node = _ref4[0],
      path = _ref4[1];
    normalizeNode([node, path]);
    if (!(0, import_server3.isElement)(node)) {
      return;
    }
    var isCodeBlockRoot = node.type === codeBlockType;
    if (isCodeBlockRoot) {
      var nonCodeLine = (0, import_server3.getChildren)([node, path]).find(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 1),
          child = _ref6[0];
        return child.type !== codeLineType;
      });
      if (nonCodeLine) {
        (0, import_server3.setNodes)(editor, {
          type: codeLineType
        }, {
          at: nonCodeLine[1]
        });
      }
    }
  };
};

// src/shared/queries/getCodeLineEntry.ts
var import_server4 = require("@udecode/plate-common/server");
var _getCodeLineEntry = function _getCodeLineEntry(editor) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref7$at = _ref7.at,
    at = _ref7$at === void 0 ? editor.selection : _ref7$at;
  if (at && (0, import_server4.someNode)(editor, {
    at: at,
    match: {
      type: _getCodeLineType(editor)
    }
  })) {
    var selectionParent = (0, import_server4.getParentNode)(editor, at);
    if (!selectionParent) return;
    var _selectionParent = _slicedToArray(selectionParent, 2),
      parentPath = _selectionParent[1];
    var codeLine = (0, import_server4.getAboveNode)(editor, {
      at: at,
      match: {
        type: _getCodeLineType(editor)
      }
    }) || (0, import_server4.getParentNode)(editor, parentPath);
    if (!codeLine) return;
    var _codeLine = _slicedToArray(codeLine, 2),
      codeLineNode = _codeLine[0],
      codeLinePath = _codeLine[1];
    if ((0, import_server4.isElement)(codeLineNode) && codeLineNode.type !== _getCodeLineType(editor)) return;
    var codeBlock = (0, import_server4.getParentNode)(editor, codeLinePath);
    if (!codeBlock) return;
    return {
      codeBlock: codeBlock,
      codeLine: codeLine
    };
  }
};

// src/shared/queries/getIndentDepth.ts
var import_server5 = require("@udecode/plate-common/server");
var _getIndentDepth = function _getIndentDepth(editor, _ref8) {
  var codeLine = _ref8.codeLine;
  var _codeLine2 = _slicedToArray(codeLine, 2),
    codeLinePath = _codeLine2[1];
  var text = (0, import_server5.getEditorString)(editor, codeLinePath);
  return text.search(/\S|$/);
};

// src/shared/queries/isCodeBlockEmpty.ts
var import_server6 = require("@udecode/plate-common/server");
var _isCodeBlockEmpty = function _isCodeBlockEmpty(editor) {
  var _a;
  var _ref9 = (_a = _getCodeLineEntry(editor)) != null ? _a : {},
    codeBlock = _ref9.codeBlock;
  if (!codeBlock) return false;
  var codeLines = Array.from((0, import_server6.getChildren)(codeBlock));
  if (codeLines.length === 0) return true;
  if (codeLines.length > 1) return false;
  var firstCodeLineNode = codeLines[0][0];
  return !(0, import_server6.getNodeString)(firstCodeLineNode);
};

// src/shared/queries/isSelectionAtCodeBlockStart.ts
var import_server7 = require("@udecode/plate-common/server");
var _isSelectionAtCodeBlockStart = function _isSelectionAtCodeBlockStart(editor) {
  var _a;
  var selection = editor.selection;
  if (!selection || (0, import_server7.isExpanded)(selection)) return false;
  var _ref10 = (_a = _getCodeLineEntry(editor)) != null ? _a : {},
    codeBlock = _ref10.codeBlock;
  if (!codeBlock) return false;
  return (0, import_server7.isStartPoint)(editor, selection.anchor, codeBlock[1]);
};

// src/shared/transforms/deleteStartSpace.ts
var import_server8 = require("@udecode/plate-common/server");
var _deleteStartSpace = function _deleteStartSpace(editor, _ref11) {
  var codeLine = _ref11.codeLine;
  var _codeLine3 = _slicedToArray(codeLine, 2),
    codeLinePath = _codeLine3[1];
  var codeLineStart = (0, import_server8.getStartPoint)(editor, codeLinePath);
  var codeLineEnd = codeLineStart && (0, import_server8.getPointAfter)(editor, codeLineStart);
  var spaceRange = codeLineEnd && (0, import_server8.getRange)(editor, codeLineStart, codeLineEnd);
  var spaceText = (0, import_server8.getEditorString)(editor, spaceRange);
  if (/\s/.test(spaceText)) {
    (0, import_server8.deleteText)(editor, {
      at: spaceRange
    });
    return true;
  }
  return false;
};

// src/shared/transforms/indentCodeLine.ts
var import_server9 = require("@udecode/plate-common/server");
var _indentCodeLine = function _indentCodeLine(editor, _ref12) {
  var codeLine = _ref12.codeLine,
    _ref12$indentDepth = _ref12.indentDepth,
    indentDepth = _ref12$indentDepth === void 0 ? 2 : _ref12$indentDepth;
  var _a;
  var _codeLine4 = _slicedToArray(codeLine, 2),
    codeLinePath = _codeLine4[1];
  var codeLineStart = (0, import_server9.getStartPoint)(editor, codeLinePath);
  var indent = " ".repeat(indentDepth);
  if (!(0, import_server9.isExpanded)(editor.selection)) {
    var cursor = (_a = editor.selection) == null ? void 0 : _a.anchor;
    var range = (0, import_server9.getRange)(editor, codeLineStart, cursor);
    var text = (0, import_server9.getEditorString)(editor, range);
    if (/\S/.test(text)) {
      (0, import_server9.insertText)(editor, indent, {
        at: editor.selection
      });
      return;
    }
  }
  (0, import_server9.insertText)(editor, indent, {
    at: codeLineStart
  });
};

// src/shared/transforms/insertCodeBlock.ts
var import_server10 = require("@udecode/plate-common/server");
var _insertCodeBlock = function _insertCodeBlock(editor) {
  var insertNodesOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!editor.selection || (0, import_server10.isExpanded)(editor.selection)) return;
  var matchCodeElements = function matchCodeElements(node) {
    return node.type === (0, import_server10.getPluginType)(editor, _ELEMENT_CODE_BLOCK) || node.type === _getCodeLineType(editor);
  };
  if ((0, import_server10.someNode)(editor, {
    match: matchCodeElements
  })) {
    return;
  }
  if (!(0, import_server10.isSelectionAtBlockStart)(editor)) {
    editor.insertBreak();
  }
  (0, import_server10.setElements)(editor, {
    children: [{
      text: ""
    }],
    type: _getCodeLineType(editor)
  }, insertNodesOptions);
  (0, import_server10.wrapNodes)(editor, {
    children: [],
    type: (0, import_server10.getPluginType)(editor, _ELEMENT_CODE_BLOCK)
  }, insertNodesOptions);
};

// src/shared/transforms/insertCodeLine.ts
var import_server11 = require("@udecode/plate-common/server");
var _insertCodeLine = function _insertCodeLine(editor) {
  var indentDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (editor.selection) {
    var indent = " ".repeat(indentDepth);
    (0, import_server11.insertElements)(editor, {
      children: [{
        text: indent
      }],
      type: _getCodeLineType(editor)
    });
  }
};

// src/shared/transforms/insertEmptyCodeBlock.ts
var import_server12 = require("@udecode/plate-common/server");
var _insertEmptyCodeBlock = function _insertEmptyCodeBlock(editor) {
  var _ref13 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref13$defaultType = _ref13.defaultType,
    defaultType = _ref13$defaultType === void 0 ? (0, import_server12.getPluginType)(editor, import_server12.ELEMENT_DEFAULT) : _ref13$defaultType,
    insertNodesOptions = _ref13.insertNodesOptions;
  if (!editor.selection) return;
  if ((0, import_server12.isExpanded)(editor.selection) || !(0, import_server12.isBlockAboveEmpty)(editor)) {
    (0, import_server12.insertElements)(editor, {
      children: [{
        text: ""
      }],
      type: defaultType
    }, __spreadValues({
      nextBlock: true,
      select: true
    }, insertNodesOptions));
  }
  _insertCodeBlock(editor, insertNodesOptions);
};

// src/shared/transforms/outdentCodeLine.ts
var _outdentCodeLine = function _outdentCodeLine(editor, _ref14) {
  var codeBlock = _ref14.codeBlock,
    codeLine = _ref14.codeLine;
  var deleted = _deleteStartSpace(editor, {
    codeBlock: codeBlock,
    codeLine: codeLine
  });
  deleted && _deleteStartSpace(editor, {
    codeBlock: codeBlock,
    codeLine: codeLine
  });
};

// src/shared/transforms/toggleCodeBlock.ts
var import_server14 = require("@udecode/plate-common/server");

// src/shared/transforms/unwrapCodeBlock.ts
var import_server13 = require("@udecode/plate-common/server");
var _unwrapCodeBlock = function _unwrapCodeBlock(editor) {
  if (!editor.selection) return;
  var codeBlockType = (0, import_server13.getPluginType)(editor, _ELEMENT_CODE_BLOCK);
  var defaultType = (0, import_server13.getPluginType)(editor, import_server13.ELEMENT_DEFAULT);
  (0, import_server13.withoutNormalizing)(editor, function () {
    var codeBlockEntries = (0, import_server13.getNodeEntries)(editor, {
      at: editor.selection,
      match: {
        type: codeBlockType
      }
    });
    var reversedCodeBlockEntries = Array.from(codeBlockEntries).reverse();
    var _iterator3 = _createForOfIteratorHelper(reversedCodeBlockEntries),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var codeBlockEntry = _step3.value;
        var codeLineEntries = (0, import_server13.getChildren)(codeBlockEntry);
        var _iterator4 = _createForOfIteratorHelper(codeLineEntries),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _step4$value = _slicedToArray(_step4.value, 2),
              path = _step4$value[1];
            (0, import_server13.setElements)(editor, {
              type: defaultType
            }, {
              at: path
            });
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        (0, import_server13.unwrapNodes)(editor, {
          at: codeBlockEntry[1],
          match: {
            type: codeBlockType
          },
          split: true
        });
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  });
};

// src/shared/transforms/toggleCodeBlock.ts
var _toggleCodeBlock = function _toggleCodeBlock(editor) {
  if (!editor.selection) return;
  var codeBlockType = (0, import_server14.getPluginType)(editor, _ELEMENT_CODE_BLOCK);
  var codeLineType = _getCodeLineType(editor);
  var isActive = (0, import_server14.someNode)(editor, {
    match: {
      type: codeBlockType
    }
  });
  (0, import_server14.withoutNormalizing)(editor, function () {
    _unwrapCodeBlock(editor);
    if (!isActive) {
      (0, import_server14.setElements)(editor, {
        type: codeLineType
      });
      var codeBlock = {
        children: [],
        type: codeBlockType
      };
      (0, import_server14.wrapNodes)(editor, codeBlock);
    }
  });
};

// src/shared/withCodeBlock.ts
var _withCodeBlock = function _withCodeBlock(editor) {
  var insertBreak = editor.insertBreak;
  var insertBreakCodeBlock = function insertBreakCodeBlock() {
    if (!editor.selection) return;
    var res = _getCodeLineEntry(editor, {});
    if (!res) return;
    var codeBlock = res.codeBlock,
      codeLine = res.codeLine;
    var indentDepth = _getIndentDepth(editor, {
      codeBlock: codeBlock,
      codeLine: codeLine
    });
    insertBreak();
    _indentCodeLine(editor, {
      codeBlock: codeBlock,
      codeLine: codeLine,
      indentDepth: indentDepth
    });
    return true;
  };
  editor.insertBreak = function () {
    if (insertBreakCodeBlock()) return;
    insertBreak();
  };
  editor.insertFragment = _insertFragmentCodeBlock(editor);
  editor.normalizeNode = _normalizeCodeBlock(editor);
  return editor;
};

// src/client/decorateCodeLine.ts
var import_server15 = require("@udecode/plate-common/server");
var _decorateCodeLine = function _decorateCodeLine(editor) {
  var code_block = (0, import_server15.getPlugin)(editor, _ELEMENT_CODE_BLOCK);
  var code_line = (0, import_server15.getPlugin)(editor, _ELEMENT_CODE_LINE);
  var Prism = code_block.options.prism;
  if (!Prism) return function () {
    return [];
  };
  var Token = Prism.Token,
    languages = Prism.languages,
    tokenize = Prism.tokenize;
  return function (_ref15) {
    var _ref16 = _slicedToArray(_ref15, 2),
      node = _ref16[0],
      path = _ref16[1];
    var _a;
    var ranges = [];
    if (!code_block.options.syntax || node.type !== code_line.type) {
      return ranges;
    }
    var codeBlock = (0, import_server15.getParentNode)(editor, path);
    if (!codeBlock) {
      return ranges;
    }
    var langName = (_a = codeBlock[0].lang) != null ? _a : "";
    if (langName === "plain") {
      langName = "";
    }
    var lang = languages[langName];
    if (!lang) {
      return ranges;
    }
    var text = (0, import_server15.getNodeString)(node);
    var tokens = tokenize(text, lang);
    var offset = 0;
    var _iterator5 = _createForOfIteratorHelper(tokens),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var element = _step5.value;
        if (element instanceof Token) {
          ranges.push(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _ELEMENT_CODE_SYNTAX, true), "anchor", {
            offset: offset,
            path: path
          }), "focus", {
            offset: offset + element.length,
            path: path
          }), "tokenType", element.type));
        }
        offset += element.length;
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
    return ranges;
  };
};

// src/client/onKeyDownCodeBlock.ts
var import_plate_common = require("@udecode/plate-common");
var import_server16 = require("@udecode/plate-common/server");
var _onKeyDownCodeBlock = function _onKeyDownCodeBlock(editor) {
  return function (e) {
    if (e.defaultPrevented) return;
    var isTab = import_plate_common.Hotkeys.isTab(editor, e);
    var isUntab = import_plate_common.Hotkeys.isUntab(editor, e);
    if (isTab || isUntab) {
      var _codeLines = (0, import_server16.getNodeEntries)(editor, {
        match: {
          type: _getCodeLineType(editor)
        }
      });
      var codeLines = Array.from(_codeLines);
      if (codeLines.length > 0) {
        e.preventDefault();
        var _codeLines$ = _slicedToArray(codeLines[0], 2),
          firstLinePath = _codeLines$[1];
        var codeBlock = (0, import_server16.getParentNode)(editor, firstLinePath);
        if (!codeBlock) return;
        (0, import_server16.withoutNormalizing)(editor, function () {
          var _iterator6 = _createForOfIteratorHelper(codeLines),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var codeLine = _step6.value;
              if (isUntab) {
                _outdentCodeLine(editor, {
                  codeBlock: codeBlock,
                  codeLine: codeLine
                });
              }
              if (isTab) {
                _indentCodeLine(editor, {
                  codeBlock: codeBlock,
                  codeLine: codeLine
                });
              }
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        });
      }
    }
    if ((0, import_server16.isHotkey)("mod+a", e)) {
      var res = _getCodeLineEntry(editor, {});
      if (!res) return;
      var _codeBlock = res.codeBlock;
      var _codeBlock2 = _slicedToArray(_codeBlock, 2),
        codeBlockPath = _codeBlock2[1];
      if ((0, import_server16.isSelectionAtBlockEnd)(editor) && (0, import_server16.isSelectionAtBlockStart)(editor)) return;
      (0, import_server16.select)(editor, codeBlockPath);
      e.preventDefault();
      e.stopPropagation();
    }
  };
};

// src/client/createCodeBlockPlugin.ts
var _createCodeBlockPlugin = (0, import_server17.createPluginFactory)({
  deserializeHtml: _deserializeHtmlCodeBlock,
  handlers: {
    onKeyDown: _onKeyDownCodeBlock
  },
  isElement: true,
  key: _ELEMENT_CODE_BLOCK,
  options: {
    hotkey: ["mod+opt+8", "mod+shift+8"],
    syntax: true,
    syntaxPopularFirst: false
  },
  plugins: [{
    isElement: true,
    key: _ELEMENT_CODE_LINE
  }, {
    decorate: _decorateCodeLine,
    isLeaf: true,
    key: _ELEMENT_CODE_SYNTAX
  }],
  then: function then(editor) {
    return {
      inject: {
        pluginsByKey: _defineProperty({}, import_server17.KEY_DESERIALIZE_HTML, {
          editor: {
            insertData: {
              query: function query() {
                var code_line = (0, import_server17.getPlugin)(editor, _ELEMENT_CODE_LINE);
                return !(0, import_server17.someNode)(editor, {
                  match: {
                    type: code_line.type
                  }
                });
              }
            }
          }
        })
      }
    };
  },
  withOverrides: _withCodeBlock
});

// src/client/hooks/useCodeBlockCombobox.ts
var import_react = __toESM(require("react"));
var import_plate_common2 = require("@udecode/plate-common");
var import_server18 = require("@udecode/plate-common/server");
var import_slate_react = require("slate-react");
var _useCodeBlockComboboxState = function _useCodeBlockComboboxState() {
  var _a;
  var editor = (0, import_plate_common2.useEditorRef)();
  var readOnly = (0, import_slate_react.useReadOnly)();
  var element = (0, import_plate_common2.useElement)();
  var _import_react$default = import_react.default.useState((_a = element.lang) != null ? _a : "text"),
    _import_react$default2 = _slicedToArray(_import_react$default, 2),
    value = _import_react$default2[0],
    setValue = _import_react$default2[1];
  var _ref17 = (0, import_server18.getPluginOptions)(editor, _ELEMENT_CODE_BLOCK),
    syntaxPopularFirst = _ref17.syntaxPopularFirst;
  import_react.default.useEffect(function () {
    var _a2;
    setValue((_a2 = element.lang) != null ? _a2 : "text");
  }, [element.lang]);
  return {
    element: element,
    readOnly: readOnly,
    setValue: setValue,
    syntaxPopularFirst: syntaxPopularFirst,
    value: value
  };
};
var _useCodeBlockCombobox = function _useCodeBlockCombobox(_ref18) {
  var element = _ref18.element,
    setValue = _ref18.setValue;
  var editor = (0, import_plate_common2.useEditorRef)();
  return {
    commandItemProps: {
      onSelect: function onSelect(_value) {
        var path = (0, import_plate_common2.findNodePath)(editor, element);
        path && (0, import_server18.setNodes)(editor, {
          lang: _value
        }, {
          at: path
        });
        setValue(_value);
      }
    }
  };
};

// src/client/hooks/useCodeBlockElement.ts
var import_react2 = __toESM(require("react"));
var import_plate_common3 = require("@udecode/plate-common");
var import_server19 = require("@udecode/plate-common/server");
var _useCodeBlockElementState = function _useCodeBlockElementState(_ref19) {
  var element = _ref19.element;
  var editor = (0, import_plate_common3.useEditorRef)();
  var _import_react2$defaul = import_react2.default.useState(false),
    _import_react2$defaul2 = _slicedToArray(_import_react2$defaul, 2),
    domLoaded = _import_react2$defaul2[0],
    setDomLoaded = _import_react2$defaul2[1];
  var lang = element.lang;
  var codeClassName = lang ? "".concat(lang, " language-").concat(lang) : "";
  import_react2.default.useEffect(function () {
    setDomLoaded(true);
  }, []);
  var _ref20 = (0, import_server19.getPluginOptions)(editor, _ELEMENT_CODE_BLOCK),
    syntax = _ref20.syntax;
  return {
    className: domLoaded && codeClassName,
    syntax: syntax
  };
};

// src/client/hooks/useCodeSyntaxLeaf.tsx
var _useCodeSyntaxLeaf = function _useCodeSyntaxLeaf(_ref21) {
  var leaf = _ref21.leaf;
  return {
    tokenProps: {
      className: "prism-token token ".concat(leaf.tokenType)
    }
  };
};

// src/client/hooks/useToggleCodeBlockButton.ts
var import_plate_common4 = require("@udecode/plate-common");
var _useToggleCodeBlockButton = function _useToggleCodeBlockButton() {
  var editor = (0, import_plate_common4.useEditorRef)();
  return {
    props: {
      onClick: function onClick() {
        _toggleCodeBlock(editor);
      },
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
      }
    }
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ELEMENT_CODE_BLOCK: _ELEMENT_CODE_BLOCK,
  ELEMENT_CODE_LINE: _ELEMENT_CODE_LINE,
  ELEMENT_CODE_SYNTAX: _ELEMENT_CODE_SYNTAX,
  createCodeBlockPlugin: _createCodeBlockPlugin,
  decorateCodeLine: _decorateCodeLine,
  deleteStartSpace: _deleteStartSpace,
  deserializeHtmlCodeBlock: _deserializeHtmlCodeBlock,
  getCodeLineEntry: _getCodeLineEntry,
  getCodeLineType: _getCodeLineType,
  getIndentDepth: _getIndentDepth,
  indentCodeLine: _indentCodeLine,
  insertCodeBlock: _insertCodeBlock,
  insertCodeLine: _insertCodeLine,
  insertEmptyCodeBlock: _insertEmptyCodeBlock,
  insertFragmentCodeBlock: _insertFragmentCodeBlock,
  isCodeBlockEmpty: _isCodeBlockEmpty,
  isSelectionAtCodeBlockStart: _isSelectionAtCodeBlockStart,
  normalizeCodeBlock: _normalizeCodeBlock,
  onKeyDownCodeBlock: _onKeyDownCodeBlock,
  outdentCodeLine: _outdentCodeLine,
  toggleCodeBlock: _toggleCodeBlock,
  unwrapCodeBlock: _unwrapCodeBlock,
  useCodeBlockCombobox: _useCodeBlockCombobox,
  useCodeBlockComboboxState: _useCodeBlockComboboxState,
  useCodeBlockElementState: _useCodeBlockElementState,
  useCodeSyntaxLeaf: _useCodeSyntaxLeaf,
  useToggleCodeBlockButton: _useToggleCodeBlockButton,
  withCodeBlock: _withCodeBlock
});